// const DELETE_TODO = 'DELETE_TODO'
// const ALLJOBS="GET_ALL_JOBS"
import {API_BASE_URL} from '../config'
export const promise=(id)=> {
    return (dispatch) => {
        alert(id)
        return new Promise((resolve) => { 
            dispatch({type: "GET_ALL_JOBS", payload: "idfyhi"})
            resolve("fgkdfgh");
        });
    };
}
export const getAlljobs=(oldRecode,data,reducername)=> {
    return (dispatch) => {
        //alert(c_name)
        return new Promise(async(resolve,reject) => { 
            // var data = new FormData();
            // data.append("action", "get_job")
            // data.append("page_no", page_no)
            // data.append("c_name", c_name)
            // data.append("j_type", j_type)
            // data.append("j_category", j_category)
            
            
            const requestOptions = {
              method: 'post',
              body: data
            };
           await fetch(API_BASE_URL+'data_process.php', requestOptions)
              .then((response) => response.json())
              .then(async(responseJson) => {
                // console.log(responseJson,"dfdg")
               // var allData=data.push(responseJson.data[0])
               // responseJson.data=  allData
              //console.log(oldRecode,"oldrecode")
              var Recode=oldRecode
              //await responseJson.data.map((item)=>{Recode.push(item)})
             var allRecode= Recode.concat(responseJson.data); 
               responseJson.data= allRecode
             //  console.log(responseJson.data)
             if(reducername){
              await dispatch({type: reducername, payload: responseJson})
             }else{
              await dispatch({type: "GET_ALL_JOBS", payload: responseJson})
             }
             
              await resolve(responseJson);
              })
              .catch((error) => {
                reject(error)
              });
        });
    };
}
export const getAllCandidates=(page_no,oldRecode)=> {
  return (dispatch) => {
      return new Promise(async(resolve,reject) => { 
          var data = new FormData();
          data.append("action", "get_all_user")
          data.append("page_no", page_no)
         // console.log(data, "data")
          const requestOptions = {
            method: 'post',
            body: data
          };
         await fetch(API_BASE_URL+'data_process.php', requestOptions)
            .then((response) => response.json())
            .then(async(responseJson) => {
              //console.log(responseJson,"dfdg")
          var Recode=oldRecode
            var allRecode= Recode.concat(responseJson.data); 
              responseJson.data= allRecode
             await dispatch({type: "GET_ALL_CANDIDATES", payload: responseJson})
            await resolve(responseJson);
            })
            .catch((error) => {
              reject(error)
            });
      });
  };
}

export const getAllField=()=>{
  return (dispatch) => {
    var data=new FormData()
   data.append("action", "get_search_field_data")
 // console.log(data, "data")

  const requestOptions = {
      method: 'post',
      body: data
  };
  fetch(API_BASE_URL+'data_process.php', requestOptions)
      .then((response) => response.json())
      .then(async(responseJson) => {
          //console.log(responseJson);
          await dispatch({type: "ALL_FEILD", payload: responseJson})

      })
      .catch((error) => {
          //console.error(error);
      });
    }
}
// export const getAllCandidates=(page_no,oldRecode)=> {
//     return (dispatch) => {
//        // alert(id)
//         return new Promise((resolve,reject) => { 
//             var data = new FormData();
//             data.append("action", "get_all_user")
//             data.append("page_no", page_no)
//             console.log(data, "data")
//             const requestOptions = {
//               method: 'post',
//               body: data
//             };
//             fetch('http://198.12.250.19:8080/~projectd/react_job_portal/data_process.php', requestOptions)
//               .then((response) => response.json())
//               .then((responseJson) => {
//                 var Recode=oldRecode
//                var allRecode= Recode.concat(responseJson.data); 
//                  responseJson.data= allRecode
//                 dispatch({type: "GET_ALL_CANDIDATES", payload: responseJson})
//                 resolve(responseJson);
//               })
//               .catch((error) => {
//                 reject(error)
//               });
//         });
//     };
// }
